/* eslint-disable camelcase */
const TOKEN = process.env.MIXPANEL_TOKEN;
const isProduction = process.env.NODE_ENV === 'production';
let mixpanel = null;

// Don't allow this to be initialized on the server
if (TOKEN && typeof __CLIENT__ !== 'undefined' && __CLIENT__) {
  mixpanel = require('mixpanel-browser'); // eslint-disable-line global-require
  mixpanel.init(TOKEN);
}

function validateBasicProperties(properties) {
  if (!properties) {
    throw new Error('Properties must be provided to an event to track');
  }

  ['companyIdentifier', 'companyId'].forEach((requiredProperty) => {
    if (!properties[requiredProperty]) {
      throw new Error(`Property '${requiredProperty}' is required to track an event`);
    }
  });
}

function trackWrapper(event, properties) {
  // Allow this to just silently do nothing when called without a token or is not prod
  if (!mixpanel || !isProduction) {
    return;
  }

  // Ensure we got the properties Voyager wants at minimum
  validateBasicProperties(properties);

  mixpanel.track(event, properties);
}

function alias(tenant) {
  if (!mixpanel || !tenant || !tenant.id || !isProduction) {
    return;
  }

  mixpanel.alias(tenant.id);
  mixpanel.people.set_once({
    id: tenant.id,
    $first_name: tenant.firstName,
    $last_name: tenant.lastName,
  });
}

/**
 * We're going to expose tracking events through this interface so we don't have
 * raw mixpanel usage where people might miss the event name or needed properties.
 */
export default {
  trackPageView(properties) {
    trackWrapper('Page View', properties);
  },

  trackInquiry(properties, tenant) {
    trackWrapper('Inquiry', properties);
    alias(tenant);
  },

  trackCoupon(properties, tenant) {
    trackWrapper('Coupon', properties);
    alias(tenant);
  },

  trackReservation(properties, tenant) {
    trackWrapper('Reservation', properties);
    alias(tenant);
  },

  getDistinctId() {
    if (!mixpanel) {
      return null;
    }

    return mixpanel.get_distinct_id();
  },
};
